function escapeCSVCell(value: string): string {
  return `"${value.replace(/"/g, '""')}"`
}

export function downloadCSV(data: string[][], filename: string) {
  const csvContent = data.map(row => row.map(escapeCSVCell).join(',')).join('\n')

  const blob = new Blob([csvContent], { type: 'text/csv' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}
